import { NavLink } from 'react-router-dom';
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import iconReviewFeedback from "../../assets/images/icon_review_feedback.png";
import iconSiteInformation from "../../assets/images/icon_site_information.png";
import iconRewards from "../../assets/images/icon_reward.png";
import iconDashboard from "../../assets/images/icon_dashboard.png";
import iconShops from "../../assets/images/iocn_shop.png";
import iconCall from "../../assets/images/icon_contact_us.png"
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import WebService from '../../Services/WebService';

const VerticalMenu = () => {
    const user = useSelector((state: RootState) => state?.user?.info);
    const truckStopOwnerType = user?.truckStopOwner?.type;
    const { t } = useTranslation()
    const [countDetail, setCountDetail] = useState<any>({})

    useEffect(() => {
        getCountDetailApi();

    }, []);

    const getCountDetailApi = async () => {

        try {

            const res: any = await WebService.getAPI({
                action: `truckstopowner-profile/pending-review-count`,
                isShowError: true,
            });
            console.log('res for Count Detail Api==>>', res)
            setCountDetail(res)
        } catch (error) {
            toast.error("Failed to load");
        } finally {

        }
    };


    // If truck stop owner type is SHOP_OWNER, show only Rewards menu
    if (truckStopOwnerType === "SHOP_OWNER") {
        return (
            <>
                <div id="vertical_menu" className="verticle-menu">
                    <div className="menu-list">
                        <NavLink id="t-1" to={'/promotions-food-specials'} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}> <img src={iconRewards} alt="Rewards" className="menu-icon" /> <span className='nav-text'>Rewards</span></NavLink>
                    </div>
                </div>
            </>
        )
    }

    // For other user types, show all menu items
    return (
        <>
            <div id="vertical_menu" className="verticle-menu">
                <div className="menu-list">
                    <NavLink id="t-1" to={'/dashboard'} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}> <img src={iconDashboard} alt="Dashboard" className="menu-icon" /> <span className='nav-text'>{t('dashboard')}</span></NavLink>
                    <NavLink id="t-1" to={'/promotions-food-specials'} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}> <img src={iconRewards} alt="Rewards" className="menu-icon" /> <span className='nav-text'>{t('rewards')}</span></NavLink>
                    <NavLink id="t-1" to={'/review-feedback'} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}> <img src={iconReviewFeedback} alt="Review & Feedback" className="menu-icon" /> <span className='nav-text'>{t('review_and_feedback')}
                        {countDetail?.pending_review_count > 0 && (
                            <span className="ml-2 bg-red-500 text-white text-[10px] font-bold px-2 py-[2px] rounded-full min-w-[20px] text-center">
                                {countDetail?.pending_review_count}
                            </span>
                        )}</span></NavLink>
                    <NavLink id="t-1" to={'/site-information'} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}> <img src={iconSiteInformation} alt="Site information" className="menu-icon" /> <span className='nav-text'>{t('site_information')}</span></NavLink>
                    <NavLink id="t-1" to={'/shops'} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}> <img src={iconShops} alt="Shops" className="menu-icon" /> <span className='nav-text'>{t('shops')}</span></NavLink>
                    <NavLink id="t-1" to={'/contact-us'} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}> <img src={iconCall} alt="ContactUS" className="menu-icon" /> <span className='nav-text'>{t('contact_us')}</span></NavLink>

                </div>
            </div>
        </>
    )
}
export default VerticalMenu;